import React from "react";
import { connect } from "react-redux";
import { onPresAddEvent } from "../actions";
import mainHelper, {apiCall} from "../helpers/MainHelper";
import ReactLoading from "react-loading";


class AddEventModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      start: '',
      end: '',
      description: '',
      all_day: false,
      loading:false
    };
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };
  handleAddEvent = async (event) => {
    event.preventDefault();
    this.setState({loading:true})
    const { title, start, end, all_day,description } = this.state;
    try {
      const response = await apiCall('business/events/add','post',{ title:title, start:start, end:end, all_day:all_day, description:description });
      this.props.onPresAddEvent();
      mainHelper.toastMessage('success',response.message);
      this.props.getEvents();
      this.setState({loading:false})
    }catch (e) {
      this.setState({loading:false})
    }

  };
  render() {
    const { isEventModal } = this.props;
    const { loading } = this.state;

    return (
        <div
            className={isEventModal ? "modal fade show" : "modal fade"}
            role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="title" id="defaultModalLabel">
                  Etkinlik ekle
                </h4>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <div className="form-line">
                    <input
                        name="title"
                        id="title"
                        type="text"
                        className="form-control"
                        placeholder="Etkinlik başlığı"
                        value={this.state.title}
                        onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-line">
                    <input
                        name="start"
                        id="start"
                        type="datetime-local"
                        className="form-control"
                        placeholder="Başlangıç tarihi"
                        value={this.state.start}
                        onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-line">
                    <input
                        name="end"
                        id="end"
                        type="datetime-local"
                        className="form-control"
                        placeholder="Bitiş tarihi"
                        value={this.state.end}
                        onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-line">
                    <textarea
                        name="description"
                        id="description"
                        className="form-control"
                        placeholder="Etkinlik detayı"
                        value={this.state.description}
                        onChange={this.handleInputChange}>
                    </textarea>
                  </div>
                </div>

              </div>
              <div className="modal-footer">

                {loading ? (
                   <button className="btn btn-outline-primary btn-lg" disabled={true}
                            style={{textAlign: "-webkit-center"}}>
                      Lütfen Bekleyin...
                      <ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2"/>
                    </button>
                ) : (
                    <button type="button" className="btn btn-outline-primary" onClick={this.handleAddEvent}>
                      Ekle
                    </button>
                )}
                <button
                    type="button"
                    onClick={this.props.onPresAddEvent}
                    className="btn btn-simple"
                    data-dismiss="modal"
                >
                  Kapat
                </button>
              </div>
            </div>
          </div>

        </div>
    );
  }
}

const mapStateToProps = ({mailInboxReducer}) => ({
  isEventModal: mailInboxReducer.isEventModal,
});

export default connect(mapStateToProps, {onPresAddEvent})(AddEventModal);
